import React from 'react';
import { FaEye, FaBullseye, FaCheck } from 'react-icons/fa';
import './AboutFull.css';

const AboutFull = () => {
  const strengths = [
    'Experienced professionals across finance, audit, engineering, and technology',
    'Scalable teams supporting diverse and complex engagements',
    'Strong culture of confidentiality, ethics, and independence',
    'Continuous training and development for our people',
    'Process-driven and quality-focused approach aligned with global standards'
  ];

  return (
    <section id="about" className="about-full section">
      <div className="container">
        <div className="section-header animate-on-scroll">
          <span className="section-label">About Xavier & Xavier</span>
          <h2>Who We Are</h2>
        </div>
        <div className="about-description animate-on-scroll">
          <p>Xavier & Xavier is a regional leader in business consulting, financial advisory, audit, and information security services. With a multidisciplinary perspective and a strong focus on quality, we support organisations in strengthening governance, improving performance, and making informed decisions.</p>
          <p>We combine deep technical competence with practical insights, helping clients manage growth, optimise controls, mitigate risks, and stay ahead in a rapidly evolving business landscape.</p>
        </div>

        <div className="vision-mission">
          <div className="vm-card animate-on-scroll">
            <div className="vm-icon"><FaEye /></div>
            <h3>Our Vision</h3>
            <p>To be the regional benchmark for advisory and consulting excellence, delivering forward-thinking solutions that empower organisations to achieve sustainable growth and operational resilience.</p>
          </div>
          <div className="vm-card animate-on-scroll">
            <div className="vm-icon"><FaBullseye /></div>
            <h3>Our Mission</h3>
            <ul>
              <li>Transform challenges into opportunities through robust audits and financial controls</li>
              <li>Enhance operational and information security resilience for clients</li>
              <li>Deliver tailored, innovative solutions backed by industry best practices</li>
              <li>Build long-term partnerships based on trust, integrity, and mutual success</li>
            </ul>
          </div>
        </div>

        <div className="section-header animate-on-scroll">
          <span className="section-label">Leadership</span>
          <h2>Leadership Team</h2>
        </div>
        <div className="team-grid">
          <div className="team-member animate-on-scroll">
            <div className="member-info">
              <h3>M. R. Antony Xavier</h3>
              <p className="designation">B.Com, FCA, DISA – Managing Partner</p>
              <p>With more than 45 years of consulting and advisory experience, he brings deep expertise in financial management, taxation, and business strategy. His sectoral insights help deliver solutions that are aligned with each client's specific requirements.</p>
              <p>He is an effective spokesperson with strong communication skills and is known to be a voracious reader who continuously enhances his professional knowledge. He established the firm from the ground up through disciplined leadership and a commitment to excellence.</p>
            </div>
          </div>
          <div className="team-member animate-on-scroll">
            <div className="member-info">
              <h3>R. X. Mike Augustus Richards</h3>
              <p className="designation">B.E., FCA, CISA – Associate Partner</p>
              <p>A Chartered Accountant, Engineer, and Certified Information Security Auditor with more than 15 years of cross-industry experience. He leads the firm's Information Security, IT Audit, Data Analytics, and Technology Assurance practices.</p>
              <p>He brings a strong interdisciplinary perspective to assignments involving systems evaluation, risk assessment, and digital controls. His commitment to innovation, quality, and continuous improvement supports the firm's broader vision for technology-driven excellence.</p>
            </div>
          </div>
        </div>

        <div className="section-header animate-on-scroll">
          <h2>Our Strengths</h2>
        </div>
        <div className="strengths-list">
          {strengths.map((strength, index) => (
            <div key={index} className="strength-item animate-on-scroll">
              <FaCheck />
              <p>{strength}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AboutFull;
